import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const ReportingColumnsModelSchema = z
  .object({
    id: z.string(),
    report_id: z.string(),
    reporting_column_defaults_id: z.string(),
    display_order: z.number().nullish(),
    visible: z.boolean(),
    required: z.boolean(),
    column_title_override: z.string().nullish(),
    sort_key_override: z.string().nullish(),
    filter_key_override: z.string().nullish(),
    filter_type_override: z.string().nullish(),
    min_width_override: z.number().nullish(),
    freeze_column_override: z.boolean().nullish(),
    filterable_override: z.boolean().nullish(),
    editable_override: z.boolean().nullish(),
    linkable_override: z.boolean().nullish(),
    link_type_override: z.string().nullish(),
    link_id_field_override: z.string().nullish()
  })
  .strict()

const ReportingColumnsModelFields = makeFieldKeys(ReportingColumnsModelSchema)

export type ReportingColumnsModel = z.infer<typeof ReportingColumnsModelSchema>
